import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { WhiteLockIcon } from "../../common/icons";
import { useTranslation } from "../../localization/useTranslation";
import PlanDialogButtonWrapper from "../../plan/planDialogWrapper/planDialogWrapper.tsx";
import { usePlanContext } from "../../auth/planProvider/PlanProvider.tsx";
import { GetContractsPlanLimit } from "../../auth/planProvider/PlanProvider.hooks.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";
import { usePanes } from "../../main/panes/usePanes";
import CreateContractPane from "./createContractPane/CreateContractPane";

export interface IAddContractButtonProps {
    legalEntityId?: string;
}

function AddContractButton(props: IAddContractButtonProps) {
    const { translateString } = useTranslation();
    const { contractManagementFeatures } = usePlanContext();
    const { contractsPlanLimitData } = GetContractsPlanLimit();
    const { permissions } = useUserContext();
    const { open } = usePanes();

    return (
        <>
            {permissions.contractManagementPermissions.permissions.create ? (
                <PlanDialogButtonWrapper
                    text={translateString("contractLimitReached", { count: contractManagementFeatures.maxNumberOfContracts })}
                    enabled={contractsPlanLimitData?.limitReached ?? false}
                >
                    <DotLegalButton
                        buttonType="primary"
                        size="medium"
                        onClick={() => open(CreateContractPane, { legalEntityId: props.legalEntityId })}
                        disabled={contractsPlanLimitData?.limitReached}
                        endIcon={contractsPlanLimitData?.limitReached ? WhiteLockIcon : undefined}
                        toolTip={
                            contractsPlanLimitData?.limitReached
                                ? translateString("contractLimitReached", { count: contractManagementFeatures.maxNumberOfContracts })
                                : undefined
                        }
                    >
                        {translateString("createContract")}
                    </DotLegalButton>
                </PlanDialogButtonWrapper>
            ) : undefined}
        </>
    );
}

export default AddContractButton;
